// removed by extract-text-webpack-plugin
module.exports = {"link":"link___33BvM","primary":"primary___3oM0T","primary-weak":"primary-weak___3oVtF","secondary":"secondary___3t2Ai"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Link/Link.scss
// module id = hUkZ
// module chunks = 46